import Backbone from 'backbone'
import template from './select-key-set-form.hbs'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import dropdown from 'scoreboard/components/dropdown'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'

const SelectKeySetForm = Backbone.View.extend({
	tagName: 'form',

	className: 'key-set-selector',

	/**
	 * Dialog to select a keySet (used when downloading a dataset rollup tree)
	 *
	 * @constructs
	 *
	 * @param {Object} options.keySets the keySets for a dataset rollup tree
	 **/
	initialize: function(options) {
		this.options = options || {}
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
	},

	render: function() {
		this.$el.empty().append(template())
		dropdown.idLabels(this.$('select.key-sets'), this.options.keySets)

		this.markedField = new MarkedField({
			el: this.$('[name=keySetId]'),
			validator: requiredValidator
		}).render()

		this.formView.start()
		return this
	},

	submit: function () {
		let data = formHelper.readFromDom(this.el)
		this.trigger('done', data)
	},

	autoRemove: true
})

export default SelectKeySetForm
SelectKeySetForm.__filename__ = 'admin/datasets/select-key-set-form.js'
